import User from "../../assets/images/user-white.svg"
import UserBlue from "../../assets/images/user.svg"
import "./styles.scss";

const ChatBox = ({
    type,
    currentMessage,
    targetLanguage,
    sourceLanguageTranscriptionDir,
    targetLanguageTranscriptionDir,
    reverse,
    errorMessage,
}) => {
    return (
        <div className={`chatbox ${type}`}>
            <div className={`d-flex flex-row gap-3 ${type} ${reverse ? 'rev' : ''}`}>
                {type !== 'dark' && <img
                    src={type === 'light' || reverse ? User : UserBlue}
                    alt="" />
                }
                <div className={`content ${type} ${reverse ? 'rev' : ''}`}>
                    <div className="text" dir={sourceLanguageTranscriptionDir}>{currentMessage}</div>
                    {targetLanguage && <div className="translated" dir={targetLanguageTranscriptionDir}>{targetLanguage}</div>}
                    {errorMessage && <div className="error">{errorMessage}</div>}
                </div>
                {type === 'dark' && <img
                    src={UserBlue}
                    alt="" />
                }
            </div>
        </div>
    )
}

export default ChatBox;
